import Snackbar, { NOTIFICATION_VARIANT as VARIANTS } from './Snackbar';

export { VARIANTS };
export default Snackbar;
